import { createAction } from '@reduxjs/toolkit';
import { ISetLanguageActionPayload } from '@core/types/actions';

export const setLanguage = createAction<ISetLanguageActionPayload>('language/SET_LANGUAGE');
